import {
  listEditionResources,
  ListEditionResourcesRequestParams,
} from "@/requests/libraries/list-edition-resources";
import { useQuery } from "@tanstack/react-query";

export const useListEditionResources = (
  params: ListEditionResourcesRequestParams,
) => {
  return useQuery({
    queryKey: [
      "editions",
      params.editionId,
      "resource-libraries",
      params.resourceLibraryId,
      {
        q: params.q,
        types: params.types,
        page: params.page,
        size: params.size,
        sort: params.sort,
      },
    ],
    queryFn: () => listEditionResources(params),
    enabled: !!params.editionId && !!params.resourceLibraryId,
  });
};
